import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchQuery, onSearchChange, resultCount }) => {
  const handleClear = () => {
    onSearchChange('');
  };

  return (
    <div className="relative">
      <div className="relative">
        <Icon
          name="Search"
          size={16}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground pointer-events-none"
        />
        <Input
          type="search"
          placeholder="Search files and folders..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="pl-10 pr-10"
        />
        {searchQuery && (
          <button
            onClick={handleClear}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 hover:bg-muted rounded-md transition-colors"
            aria-label="Clear search"
          >
            <Icon name="X" size={16} className="text-muted-foreground" />
          </button>
        )}
      </div>
      {searchQuery && (
        <div className="mt-2 text-xs md:text-sm text-muted-foreground flex items-center gap-2">
          <Icon name="Info" size={14} />
          <span>
            {resultCount > 0
              ? `Found ${resultCount} ${resultCount === 1 ? 'result' : 'results'}`
              : 'No results found'}
          </span>
        </div>
      )}
    </div>
  );
};

export default SearchBar;